import React, { Component } from 'react';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Translate } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Breadcrumb, Button, Tabs, Tab, Dropdown, MenuItem } from 'react-bootstrap';
import { Toolbar, Data, Editors } from 'react-data-grid-addons';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import { SkyLightStateless } from 'react-skylight';
import axios from 'axios';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import { DatePicker } from '../Common/datePicker';
import CashFormatter from '../Common/cashFormatter';
import GenericDatePicker from '../Common/GenericDatePicker';
import { getFromToDates } from '../Common/cleanDates';
import { InputField } from '../Common/inputField';
import checkPermission from '../Common/permissions';
import Spinner from '../Widgets/spinner';
import { companyCodeTitle, isGGI, isVAK, isSH, isAP, isLAP, isAPD } from '../../actions/root_url';
import { BASE_USER_URL } from '../../actions/url';

momentLocalizer(moment);
const styles = {
  pastStyle:{
    width:'100%',
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    justifyContent:'center',
    marginTop: '14px',
  },
  pastTextStyle:{
    color: '#f6c244',
    fontSize: '17px'
  },
}

class RowRenderer extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };
  render() {
    const row = this.props.row;
    const style = {};
    return (
      <div
        onDoubleClick={() => {
          if(row.SalesOrder_id) {
            this.context.router.push(`/salesOrders/${row.SalesOrder_id}`);
          }
          if(row.PurchaseOrder_id) {
            window.location = `https://lap-scm.truckxi.com/purchaseOrder/${row.PurchaseOrder_id}/`
          }
        }}
        style={style}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}
class GeneralDashboard extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: 540,
        Messages: [],
        userOptions: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        userMessage: "",
        userSelectVisibility: false,
        quote: '',
        cursorPosition: 0,
        saVisibility: false, // shipping Advice

        POs: {
          rows: [],
          allRows: [],
          setDate: null,
          selectedRows: null,
          sortColumn: null,
          sortDirection: null,
        },

        SOs: {
          rows: [],
          allRows: [],
          setDate: null,
          selectedRows: null,
          sortColumn: null,
          sortDirection: null,
        },

        MSOs: {
          rows: [],
          allRows: [],
          setDate: null,
          selectedRows: null,
          sortColumn: null,
          sortDirection: null,
        },

        PODetail: {
          rows: [],
          sortColumn: null,
          sortDirection: null,
        },

        poDateChosen: (isSH || isAP) ? null : new Date(),
        soDateChosen: new Date(),
        isPastPo: false,
        isPastSo: false,
        poActivekey: 1,
        soActivekey: 1,

        PdfFrameLoaded: true,
      };

      this.handleResize = this.handleResize.bind(this);
      this.addNewMessage = this.addNewMessage.bind(this);
      this.addNewMessage2 = this.addNewMessage2.bind(this);
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      this.props.fetchDashboardMessages(this.props.selectedCompany && this.props.selectedCompany.value);
      this.fetchUsers();
      document.addEventListener("keydown", this.handleKeyDown.bind(this));
      document.getElementById('ats').focus();
      const {selectedCompany, selectedWarehouse} = this.props;
      if((isLAP || isAPD) || isGGI) {
        const {isPastPo, isPastSo} = this.state;
        if(selectedCompany && selectedWarehouse && selectedCompany.value && selectedWarehouse.value) {
          this.props.fetchIncomingOrdersByDate({...getFromToDates(this.state.poDateChosen),selectedCompany:selectedCompany.value,selectedWarehouse:selectedWarehouse.value, isPastPo});
          this.props.fetchOutgoingOrdersByDate({...getFromToDates(this.state.soDateChosen),selectedCompany:selectedCompany.value,selectedWarehouse:selectedWarehouse.value, isPastSo});
        }
      } else if (isSH || isAP) {
        // for isSH default null and set as 1 year each front and back
        // const date = getFromToDates(new Date());
        // const newDate = {
        //   fromDate: this.convertUtcDate((moment(date).subtract(1, 'years')).startOf('day')),
        //   toDate: this.convertUtcDate((moment(date).add(1, 'years')).startOf('day')),
        // }
        // for isSH default null and show all
        const newDate = {
          fromDate: null,
          toDate: null,
        }
        this.props.fetchIncomingOrdersByDate(newDate);
        this.props.fetchOutgoingOrdersByDate(getFromToDates(new Date()));
      } else {
        this.props.fetchIncomingOrdersByDate(getFromToDates(new Date()));
        this.props.fetchOutgoingOrdersByDate(getFromToDates(new Date()));
      }
      if (!(isSH || isAP)) {
        this.props.setField('generalDashboard', 'selectedPODate', new Date());
      }
      this.props.setField('generalDashboard', 'selectedSODate', new Date());
    }

    componentDidUpdate(prevProps) {
      if (this.props.selectedCompany !== prevProps.selectedCompany) {
        this.props.fetchDashboardMessages(this.props.selectedCompany && this.props.selectedCompany.value);
      }
    }

    convertUtcDate(date) {
      return (date) ? moment(date).toISOString() : moment().toISOString();
    }

    handleKeyDown(event) {
      if (!this.state.userSelectVisibility) {return;}
      switch( event.key ) {
        case "Escape":
          this.setState({userSelectVisibility: false});
          document.getElementById('ats').focus();
          break;
        default:
          break;
      }
    }

    fetchUsers() {
      let {userOptions} = this.state;
      userOptions.rows = [];
      axios.get(
        `${BASE_USER_URL}users/?Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
      .then(res => {
        res && res.data && res.data.map((r,i) => {
          // userOptions.rows.push({name: r.FirstName + r.LastName, username: r.username});
          userOptions.rows.push({FullName: r.FirstName + ' ' + r.LastName, ...r});
        });
        this.setState({ userOptions });
      }, (err) => {
        if (err.data) {
          // if(!isVAK){
          //   alert(err.data);
          // }
        } else {
          alert("Server issue detected, please contact admin.");
        }
      })
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
      const {selectedCompany, selectedWarehouse} = this.props;
      if (nextProps.todaysIncomingOrders && nextProps.todaysIncomingOrders !== this.props.todaysIncomingOrders) {
        const POs = { ...this.state.POs, rows: nextProps.todaysIncomingOrders };
        this.setState({ POs });
      }

      if (nextProps.todaysOutgoingOrders && nextProps.todaysOutgoingOrders !== this.props.todaysOutgoingOrders) {
        const SOs = { ...this.state.SOs, rows: [...nextProps.todaysOutgoingOrders.SO] };
        const MSOs = { ...this.state.MSOs, rows: [...(nextProps.todaysOutgoingOrders.MSO || [])] };
        this.setState({ SOs, MSOs });
      }

      if (nextProps.purchaseOrderList && nextProps.purchaseOrderList !== this.props.purchaseOrderList) {
        const PODetail = { ...this.state.purchaseOrderDetail, rows: nextProps.purchaseOrderList };
        this.setState({ PODetail });
      }

      if(((isLAP || isAPD) || isGGI) && nextProps.selectedWarehouse && nextProps.selectedWarehouse.value &&
        selectedCompany && selectedCompany.value && nextProps.selectedWarehouse.value != selectedWarehouse.value) {
        const {isPastPo, isPastSo} = this.state;
        this.props.fetchIncomingOrdersByDate({...getFromToDates(this.state.poDateChosen),selectedCompany:nextProps.selectedCompany.value,selectedWarehouse:nextProps.selectedWarehouse.value, isPastPo});
        this.props.fetchOutgoingOrdersByDate({...getFromToDates(this.state.soDateChosen),selectedCompany:nextProps.selectedCompany.value,selectedWarehouse:nextProps.selectedWarehouse.value, isPastSo});
      }
      // if (nextProps.poDateChosen && nextProps.poDateChosen !== this.props.poDateChosen) {
      //   this.props.fetchIncomingOrdersByDate(getFromToDates(nextProps.poDateChosen));
      // }

      // if (nextProps.soDateChosen && nextProps.soDateChosen !== this.props.soDateChosen) {
      //   this.props.fetchOutgoingOrdersByDate(getFromToDates(nextProps.soDateChosen));
      // }

      if (nextProps.messages && nextProps.messages !== this.props.messages) {
        const Messages = nextProps.messages;
        this.setState({ Messages }, () => {
          this.updateScroll();
        });
      }

      if (nextProps.purchaseOrderPdf && nextProps.purchaseOrderPdf !== this.props.purchaseOrderPdf) {
        this.setState({ PdfFrameLoaded: false });
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && !this.state.PdfFrameLoaded) {
        return false;
      }
      return true;
    }

    componentWillUnmount() {
      // window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.noButton });
    }

    updateScroll() {
      const element = document.getElementById('message-box');
      element.scrollTop = element.scrollHeight;
    }

    addNewMessage() {
      const newMessage = {
        message: this.props.Message,
      };
      this.props.postDashboardMessage(newMessage);
    }

    addNewMessage2() {
      const newMessage = {
        message: this.state.userMessage,
      };
      if ((isLAP || isAPD)) {
        newMessage.message = newMessage.message.replace(this.state.quote, '').trim();
        this.setState({
          quote: '',
        });
        this.props.postDashboardMessage(newMessage, this.props.Color, this.props.Quote_id);
      } else {
        this.props.postDashboardMessage(newMessage);
      }
      this.setState({ userMessage: "" });
    }

    updateSelectedUserMessage(e) {
      if (this.state.userMessage.length >= e.target.value.length && this.state.userMessage === this.state.quote) {
        this.setState({userMessage: ''});
        this.props.setField('generalDashboard', 'Quote_id', undefined);
      } else {
        this.setState({userMessage: e.target.value});
      }
      // if (e.charCode === 13) {
      // }
      // this.props.setValue('salesQuoteForm', 'ShipVia', e.target.value);
    }

    setUserSelectVisibility = (userSelectVisibility = false) => {
      const textField = document.getElementById('ats');
      // const cursorPosition = textField.selectionStart;
      this.setState({ userSelectVisibility, cursorPosition: textField.selectionStart+1 });
    }

    setSaVisibility = (saVisibility = false) => {
      this.setState({ saVisibility });
    }

    IFrameIsLoaded = () => {
      if (!this.state.PdfFrameLoaded) {
        const pdfFrame = window.frames.purchaseOrderPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ PdfFrameLoaded: true });
      }
    };

    renderIFrame() {
      if (this.props.purchaseOrderPdf) {
        const file = window.URL.createObjectURL(this.props.purchaseOrderPdf);
        return <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoaded} id="purchaseOrderPdf" name="purchaseOrderPdf" src={file} />;
      }
      return null;
    }

    renderUserTable() {
      const getRows = () => {
        const Rows = Data.Selectors.getRows(this.state.userOptions);
        return Rows;
      };

      const getSize = () => {
        const RowSize = getRows().length;
        return RowSize;
      };

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const handleGridSort = (sortColumn, sortDirection) => {
        const userOptions = { ...this.state.userOptions, sortColumn, sortDirection };
        this.setState({ userOptions });
      };

      const onRowSelect = (rows) => {
        const userOptions = { ...this.state.userOptions, selectedRows: rows };
        this.setState({ userOptions });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.userOptions.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const userOptions = {
          ...this.state.userOptions,
          filters: newFilters,
        };
        this.setState({ userOptions });
      };

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      const handleUserClick = (val) => {
        let {userMessage} = this.state;
        // userMessage += val.username + ' ';
        let msg = null;
        msg = userMessage.slice(0, this.state.cursorPosition) + val.username + ' ' + userMessage.slice(this.state.cursorPosition);
        this.setState({userMessage: msg, userSelectVisibility: false});

        document.getElementById('ats').focus();
      }

      const columns = [
        // {
        //   key: 'FullName',
        //   name: <Translate value="full_name" />,
        //   resizable: true,
        //   sortable: true,
        //   filterable: true,
        //   width: 140,
        //   getRowMetaData: row => row,
        //   formatter: ({ value, dependentValues }) => (
        //     <div
        //       style={{ cursor: 'pointer', width: "100%", height: "100%" }}
        //       onClick={() => {
        //         handleUserClick(dependentValues);
        //       }}
        //     >
        //       {value}
        //     </div>
        //   ),
        // },
        {
          key: 'username',
          name: <Translate value="username" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 140,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ cursor: 'pointer', width: "100%", height: "100%" }}
              onClick={() => {
                handleUserClick(dependentValues);
              }}
            >
              {value}
            </div>
          ),
        },
        {
          key: 'Cellphone',
          name: <Translate value="phone" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 140,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ cursor: 'pointer', width: "100%", height: "100%" }}
              onClick={() => {
                handleUserClick(dependentValues);
              }}
            >
              {value}
            </div>
          ),
        },
      ];

      return (
      // React Table Purchase Orders
        <Row>
          <Col xs={12}>
            {/* <div id="purchase-orders-arriving-table"> */}
            <div style={{ maxWidth: '800px' }}>
              <ReactDataGrid
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                rowKey="PurchaseOrder_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={360}
                rowHeight={25}
                onRowSelect={onRowSelect}
              />
            </div>
          </Col>
        </Row>
      );
    }

    setPoDate = (e) => {
      const {selectedCompany, selectedWarehouse} = this.props;
      const {isPastPo} = this.state;
      if((isLAP || isAPD) && isPastPo) return
      this.setState(
        { poDateChosen: e },
        () => {
          if(isGGI || (isLAP || isAPD)) {
            this.props.fetchIncomingOrdersByDate({...getFromToDates(this.state.poDateChosen),selectedCompany:selectedCompany.value,selectedWarehouse:selectedWarehouse.value});
          } else {
            this.props.fetchIncomingOrdersByDate(getFromToDates(this.state.poDateChosen));
          }
         },
      );
    }

    setSoDate = (e) => {
      const {selectedCompany, selectedWarehouse} = this.props;
      const {isPastSo} = this.state;
      if((isLAP || isAPD) && isPastSo) return
      this.setState(
        { soDateChosen: e },
        () => {
          if(isGGI || (isLAP || isAPD)) {
            this.props.fetchOutgoingOrdersByDate({...getFromToDates(this.state.soDateChosen),selectedCompany:selectedCompany.value,selectedWarehouse:selectedWarehouse.value});
          } else {
            this.props.fetchOutgoingOrdersByDate(getFromToDates(this.state.soDateChosen));
          }
        },
      );
    }
    handleChangePoKey = (poActivekey) => {
      let isPastPo = false;
      if(poActivekey != 1) {
        isPastPo = true;
      }
      const {selectedCompany, selectedWarehouse} = this.props;
      this.setState({poActivekey, isPastPo}, () => {
        if(poActivekey == 1) {
          this.props.fetchIncomingOrdersByDate({...getFromToDates(this.state.poDateChosen), isPastPo: false, selectedCompany:selectedCompany.value,selectedWarehouse:selectedWarehouse.value});
        } else {
          this.props.fetchIncomingOrdersByDate({...getFromToDates(this.state.poDateChosen), isPastPo: true, selectedCompany:selectedCompany.value,selectedWarehouse:selectedWarehouse.value});
        }
      })
    }

    handleChangeSoKey = (soActivekey) => {
      let isPastSo = false;
      if(soActivekey != 1) {
        isPastSo = true;
      }
      const {selectedCompany, selectedWarehouse} = this.props;
      this.setState({soActivekey, isPastSo}, () => {
        if(soActivekey == 1) {
          this.props.fetchOutgoingOrdersByDate({...getFromToDates(this.state.soDateChosen), isPastSo: false, selectedCompany:selectedCompany.value,selectedWarehouse:selectedWarehouse.value});
        } else {
          this.props.fetchOutgoingOrdersByDate({...getFromToDates(this.state.soDateChosen), isPastSo: true, selectedCompany:selectedCompany.value,selectedWarehouse:selectedWarehouse.value});
        }
      })
    }

    renderPoTabs() {
      return <Tabs className='tab-content-dashboard' activeKey={this.state.poActivekey} justified onSelect={this.handleChangePoKey}>
        <Tab eventKey={1} title={<Translate value='po_scheduled_arrival_up'/>}>
          {this.renderPurchaseOrderTable()}
        </Tab>
        <Tab eventKey={2} title={<Translate value='past_due'/>}>
          {this.renderPurchaseOrderTable()}
        </Tab>
      </Tabs>
    }
    renderSoTabs() {
      return <Tabs className='tab-content-dashboard' activeKey={this.state.soActivekey} justified onSelect={this.handleChangeSoKey}>
        <Tab eventKey={1} title={<Translate value='so_scheduled_shipping_up'/>}>
          {this.renderSalesOrderTable() }
          {this.renderMobileSalesOrderTable()}
        </Tab>
        <Tab eventKey={2} title={<Translate value='past_due'/>}>
          {this.renderSalesOrderTable() }
          {this.renderMobileSalesOrderTable()}
        </Tab>
      </Tabs>
    }

    // Render the table head and bind it to the datatable plugin to show a sortable table.
    renderPurchaseOrderTable() {
      if (this.props.todaysIncomingOrdersIsLoading && !this.props.todaysIncomingOrdersError) return <Spinner />;
      else if (this.props.todaysIncomingOrdersError) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.todaysIncomingOrdersError)}</div>
          </ContentWrapper>
        ); // Parameters of the react-data-grid
      }

      const getRows = () => {
        const Rows = Data.Selectors.getRows(this.state.POs);
        return Rows;
      };

      const getSize = () => {
        const RowSize = getRows().length;
        return RowSize;
      };

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const POs = { ...this.state.POs, sortColumn, sortDirection };
        this.setState({ POs });
      };

      // Handle the row select function

      const onRowSelect = (rows) => {
        const POs = { ...this.state.POs, selectedRows: rows };
        this.setState({ POs });
      };

      // Custom Formatter component

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      let children = {};
      if((isLAP || isAPD)) {
        children.onRowClick = () => {
          localStorage.setItem('poDetailFrom', 'dashboard');
        }
        children.rowRenderer=<RowRenderer/>
      }

      // Column difinition
      const columns = [
        {
          key: 'PONum',
          name: <Translate value={ (isSH || isAP) ? "sa_file_no" : "po_num"} />,
          resizable: true,
          sortable: true,
          width: (isSH || isAP) ? 110 : 90,
          getRowMetaData: row => row,
          formatter: ({value, dependentValues}) => {
            if (isSH || isAP) {
              return (
                <div
                  onClick={() => {
                    this.props.fetchPurchaseOrderList(dependentValues.PurchaseOrder_id);
                    setTimeout(() => {
                      this.setSaVisibility(true);
                    }, 1000);
                  }}
                >{value}</div>
              )
            } else {
              return (
                <div>{value}</div>
              )
            }
          },
        },
        ...(isSH || isAP) ? [{
          key: 'ContainerNum',
          name: <Translate value="container_no" />,
          resizable: true,
          sortable: true,
          width: 150,
        }, {
          key: 'shipnote',
          name: <Translate value="shipping_note" />,
          resizable: true,
          sortable: true,
          width: 125,
        }, {
          key: 'ETDDate',
          name: <Translate value="ETD" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        }]: [{
          key: 'Vendor_Name',
          name: <Translate value="vendor" />,
          resizable: true,
          sortable: true,
          width: 200,
        }, {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: CashFormatter,
        }, {
          key: 'OrderDate',
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        }],
        {
          key: 'ETADate',
          name: <Translate value="ETA" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },
        ...(isSH || isAP) ? [{
          key: 'DeliveryDate',
          name: <Translate value="deliver_date" />,
          resizable: true,
          sortable: true,
          width: 130,
          formatter: DateFormatter,
        }] : [{
          key: 'Purchaser_User_Name',
          name: <Translate value="purchaser" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        }, {
          key: 'PurchaseStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 110,
        }],
      ];

      return (
      // React Table Purchase Orders
        <Row>
          <Col xs={12}>
            <div id="purchase-orders-arriving-table">
              <ReactDataGrid
                rowKey="PurchaseOrder_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={305}
                rowHeight={25}
                {...children}
                onRowSelect={onRowSelect}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderPODetailTable() {
      if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return <Spinner />;
      else if (this.props.purchaseOrderListError) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.purchaseOrderListError)}</div>
          </ContentWrapper>
        );
      }

      const getRows = () => Data.Selectors.getRows(this.state.PODetail);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const handleGridSort = (sortColumn, sortDirection) => {
        const PODetail = { ...this.state.PODetail, sortColumn, sortDirection };
        this.setState({ PODetail });
      };

      // Column difinition
      const columns = [{
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 100,
        }, {
          key: 'Name',
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 250,
        }, {
          key: 'prepare_purchase_order_num',
          name: <Translate value="po_no" />,
          resizable: true,
          sortable: true,
          width: 100,
        }, {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          width: 50,
          sortable: true,
        }, {
          key: 'OrderQuantity',
          name: <Translate value="shipped_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },{
          key: 'ReceiveQuantity',
          name: <Translate value="receive_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        }, {
          key: 'OrderUnitPrice',
          name: <Translate value="order_unit_dollarsign" />,
          resizable: true,
          width: 110,
          sortable: true,
          formatter: CashFormatter,
        },
        {
          key: 'OrderTotalPrice',
          name: <Translate value="order_total_dollarsign" />,
          resizable: true,
          width: 110,
          sortable: true,
          formatter: CashFormatter,
        }, {
          key: 'dimension_shipping',
          name: <Translate value="package_dimension_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        }, {
          key: 'ReceiveTotalWeight',
          name: <Translate value="receive_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        }, {
          key: 'ReceiveUnitPrice',
          name: <Translate value="receive_unit_dollarsign" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        }, {
          key: 'ReceiveTotalPrice',
          name: <Translate value="receive_total_dollarsign" />,
          resizable: true,
          width: 80,
          sortable: true,
          formatter: CashFormatter,
        }, {
          key: 'expire_date',
          name: <Translate value="expire_date" />,
          resizable: true,
          sortable: true,
          width: 80,
        }, {
          key: 'purchase_convert_unit',
          name: <Translate value="convert_quantity" />,
          resizable: true,
          width: 90,
          sortable: true,
        }, {
          key: 'OrderTotalNetWeight',
          name: <Translate value="order_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        }
      ];

      return (
        <Row>
          <Col xs={12}>
            <div>
              <Button
                bsStyle="primary"
                className="print-btn"
                type="button"
                disabled={this.props.requestingPurchaseOrderPdf || !checkPermission('print_purchase_order')}
                onClick={() => {
                  this.props.printPurchaseOrder(getRows()[0].purchase_order_id);
                }}
              >
                <em className="fa fa-print" />
                <Translate value="print" />
              </Button>
              <ReactDataGrid
                headerRowHeight={45}
                rowKey="PurchaseOrder_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={305}
                rowHeight={25}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderSalesOrderTable() {
      if (this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError) return <Spinner />;
      else if (this.props.todaysOutgoingOrdersError) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.todaysOutgoingOrdersError)}</div>
          </ContentWrapper>
        ); // Parameters of the react-data-grid
      }

      const getRows = () => {
        const Rows = Data.Selectors.getRows(this.state.SOs);
        return Rows;
      };

      const getSize = () => {
        const RowSize = getRows().length;
        return RowSize;
      };

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const SOs = { ...this.state.SOs, sortColumn, sortDirection };
        this.setState({ SOs });
      };

      // Custom Formatter component

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      // Column difinition
      const columns = [
        {
          key: 'SONum',
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          width: 120,
        },
        {
          key: 'Deliver_CustomerName',
          name: <Translate value="customer" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: CashFormatter,
        },
        {
          key: 'OrderDate',
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },{
          key: 'DispatchDate',
          name: <Translate value={(isLAP || isAPD) ? "etd":"dispatch"}/>,
          resizable: true,
          sortable: true,
          width: (isLAP || isAPD) ? 100 : 90,
          formatter: DateFormatter,
        },
        {
          key: 'Sales_User_Name',
          name: <Translate value="sales" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'SaleStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 110,
        },
      ];

      let children = {};
      if((isLAP || isAPD)) {
        children.onRowClick = (index) => {
          let rows = getRows();
          this.props.fetchSalesOrderDetail(rows[index].SalesOrder_id, 'salesOrders', '', '', 'dashboard')
        }
        children.rowRenderer=<RowRenderer />
      }

      return (
        <Row>
          <Col xs={12}>
            <div id="sales-orders-shipping-table">
              <ReactDataGrid
                rowKey="SalesOrder_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={305}
                {...children}
                rowHeight={25}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderMobileSalesOrderTable() {
      if (this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError || this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError) return;
      else if (this.props.todaysOutgoingOrdersError) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.todaysOutgoingOrdersError)}</div>
          </ContentWrapper>
        ); // Parameters of the react-data-grid
      }

      const getRows = () => {
        const Rows = Data.Selectors.getRows(this.state.MSOs);
        return Rows;
      };

      const getSize = () => {
        const RowSize = getRows().length;
        return RowSize;
      };

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const MSOs = { ...this.state.MSOs, sortColumn, sortDirection };
        this.setState({ MSOs });
      };

      // Custom Formatter component

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      // Column difinition
      const columns = [
        {
          key: 'SONum',
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          width: 120,
        },
        {
          key: 'Deliver_CustomerName',
          name: <Translate value="customer" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: CashFormatter,
        },
        {
          key: 'OrderDate',
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },
        {
          key: 'DispatchDate',
          name: <Translate value={(isLAP || isAPD) ?'etd':"dispatch"}/>,
          resizable: true,
          sortable: true,
          width: (isLAP || isAPD) ? 100 :90,
          formatter: DateFormatter,
        },
        {
          key: 'Sales_User_Name',
          name: <Translate value="sales" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true
        },
        {
          key: 'SaleStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 110,
        },
      ];

      return (
        <Row>
          <Col xs={12}>
            <h4 id="mso-header"><Translate value="mso_scheduled_shipping" /></h4>
            <div id="mobile-sales-orders-shipping-table">
              <ReactDataGrid
                rowKey="SalesOrder_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={305}
                rowHeight={25}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderMessages() {
      if (this.props.messagesIsLoading) {
        return (
          <Spinner />
        );
      }
      const handleMessageQuote = message => {
        this.props.setField('generalDashboard', 'Quote_id', message.id);
        const quote = 'Quote:' + message.Name;
        this.setState({
          userMessage:  quote + ' ',
          quote,
        });
      }
      const replyBtnStyle = {
        color: '#2196F3', cursor: 'pointer'
      }
      const replyMsgStyle = {
        border: '1px solid #bbb',
        marginTop: 10,
        marginBottom: 10,
        padding: 6,
      }
      return (
        <div style={{width: '98%'}}>
          {this.state.Messages.map((message) =>
            <Row className='user-message'>
              <Col xs={11}>
                <Panel>
                  <Row>
                    <Col xs={2}>
                      <span className='message-name'>{ message.Name }</span>:
                    </Col>
                    <Col xs={10}>
                      <div>
                        <span className='message-content' style={{color: message.Color ? `#${message.Color}` : undefined}}>{ message.Message }</span>
                        {!!message.Quote_Msg && <div style={replyMsgStyle}><Row>
                          <Col xs={2}>
                            <span className='message-name'>{ message.Quote_Name }</span>:
                          </Col>
                          <Col xs={10}>
                            <div>
                              <span className="message-content">{message.Quote_Msg}</span>
                            </div>
                          </Col>
                        </Row></div>}
                        {(isLAP || isAPD) && <p style={{ textAlign: 'right'}}>
                          <div>
                            <span style={replyBtnStyle} onClick={() => handleMessageQuote(message)}><Translate value="quote" /></span>
                          </div>
                        </p>}
                      </div>
                    </Col>
                  </Row>
                </Panel>
              </Col>
              <Col xs={1} className='message-timestamp'>
                <Row>
                  <Col xs={12}>
                    <span className='pull-right'>
                      { moment(message.Date).format('h:mm A') }
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <span className='pull-right'>
                      { moment(message.Date).format('MM/DD/YYYY') }
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </div>
      );
    }

    renderMessageColorPicker = () => {
      const handleChangeColor = color => {
        this.props.setField('generalDashboard', 'Color', color);
      }
      const dropdownBtnStyle = {
        width: '22px',
        height: '22px',
        backgroundColor: 'white',
        border: '1px solid #555555',
        padding: 0,
      }
      const dropdownContentStyle = {width: 18, height: 18, backgroundColor: `#${this.props.Color || '000000'}`, margin: 1}
      const dropdownMenuStyle = {width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'};
      return <div style={{width: 30, float: 'left'}}>
        <Dropdown dropup>
          <Dropdown.Toggle
            style={dropdownBtnStyle}
          >
            <div style={dropdownContentStyle} />
          </Dropdown.Toggle>
          <Dropdown.Menu style={{padding: 0}}>
            <MenuItem onSelect={() => handleChangeColor('F44336')} className={'color-picker'}>
              <div style={{ ...dropdownMenuStyle, backgroundColor: '#F44336' }}>
                <span style={{color: '#FFF'}}><Translate value="urgent"/></span>
              </div>
            </MenuItem>
            <MenuItem onSelect={() => handleChangeColor('FFA000')} className={'color-picker'}>
              <div style={{ ...dropdownMenuStyle, backgroundColor: '#FFA000' }}>
                <span style={{color: '#FFF'}}><Translate value="high"/></span>
              </div>
            </MenuItem>
            <MenuItem onSelect={() => handleChangeColor('1976D2')} className={'color-picker'}>
              <div style={{ ...dropdownMenuStyle, backgroundColor: '#1976D2' }}>
                <span style={{color: '#FFF'}}><Translate value="normal"/></span>
              </div>
            </MenuItem>
            <MenuItem onSelect={() => handleChangeColor('888888')} className={'color-picker'}>
              <div style={{...dropdownMenuStyle, backgroundColor: '#888888'}}>
                <span style={{color: '#FFF'}}><Translate value="low"/></span>
              </div>
            </MenuItem>
            <MenuItem onSelect={() => handleChangeColor('000000')} className={'color-picker'}>
              <div style={dropdownMenuStyle}>
                <span><Translate value="clear"/></span>
              </div>
            </MenuItem>
          </Dropdown.Menu>
      </Dropdown>
      </div>
    }
    render() {
      const userSelectStyle = {
        width: "300px",
        height: "500px",
        marginLeft: "-20%",
        marginTop: "-380px"
      };
      const saStyle = {
        width: "800px",
        height: "500px",
        marginLeft: "-20%",
        marginTop: "-380px",
        fontSize: "14px"
      };

      const { handleSubmit } = this.props;
      const { isPastPo } = this.state;
      const purchaseOrderTablePanelHeader = (isLAP || isAPD) ? (
        <Col>
        <Row>
          <Col xs={5}><h4><Translate value={'purchase_order'} /></h4></Col>
          {!isPastPo ?<Col xs={7} className="text-right">
            <h5 className="filter-title">
              <Translate value={ "eta_date"} /><span className="colon">:</span>
            </h5>
            {
              GenericDatePicker({
                setDate: this.setPoDate,
                selectedDate: this.state.poDateChosen,
              })
            }
          </Col>:<Col xs={7}/>}
        </Row>
      </Col>
      ) :  (
        <Row>
          <Col xs={5}><h4><Translate value={ (isSH || isAP) ? "sa_scheduled_arrival" : "po_scheduled_arrival" } /></h4></Col>
          <Col xs={7} className="text-right">
            <h5 className="filter-title">
              <Translate value={ (isSH || isAP) ? "deliver_date" : "eta_date"} /><span className="colon">:</span></h5>
            {
              GenericDatePicker({
                setDate: this.setPoDate,
                selectedDate: this.state.poDateChosen,
              })
            }
          </Col>
        </Row>
      );

      const { isPastSo } = this.state;
      const salesOrderTablePanelHeader = (isLAP || isAPD) ? (
        <Col>
        <Row>
          <Col xs={5}><h4><Translate value={'sales_order'} /></h4></Col>
          {!isPastSo ?<Col xs={7} className="text-right">
            <h5 className="filter-title">
              <Translate value="etd_date" /><span className="colon">:</span>
            </h5>
            {
              GenericDatePicker({
                setDate: this.setSoDate,
                selectedDate: this.state.soDateChosen,
              })
            }
          </Col>:<Col xs={7}/>}
        </Row>
      </Col>
      ) :  (
        <Row>
          <Col xs={5}><h4><Translate value="so_scheduled_shipping" /></h4></Col>
          <Col xs={7} className="text-right">
            <h5 className="filter-title"><Translate value="so_order_date" /><span className="colon">:</span></h5>
            {
              GenericDatePicker({
                setDate: this.setSoDate,
                selectedDate: this.state.soDateChosen,
              })
            }
          </Col>
        </Row>
      );
      const mobileSalesOrderTablePanelHeader = (
        <Row>
          <Col xs={8}><h4><Translate value="mso_scheduled_shipping" /></h4></Col>
        </Row>
      );
      const messageBoardHeader = (
          <Row>
            <Col xs={12}>
              <h4 style={{ display: 'inline' }}>
                <Translate value="message_board" />
              </h4>
              {this.props.Message && this.props.Message.length > 499 && <div id='limit-warning'><Translate value="character_limit_reached" /> (500)</div>}
              <Button
                bsStyle='primary'
                id='refresh-button'
                onClick={this.props.fetchDashboardMessages}
              >
                <em className='fa fa-refresh' />
              </Button>
            </Col>
          </Row>
        );

      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item active="true">
              <Translate value="dashboard" />
            </Breadcrumb.Item>
          </Breadcrumb>
          <Grid id="general-dashboard" fluid="true">
            {/* Tables */}
            <Row>
              <form onSubmit={handleSubmit}>
                <Col xs={6}>
                  <Row>
                    <Col xs={12}>
                      <Panel header={purchaseOrderTablePanelHeader} className={(isLAP || isAPD) ? "table-collapse-revision" : "table-collapse-fix-revision"}>
                        {(isLAP || isAPD) ? this.renderPoTabs() : this.renderPurchaseOrderTable() }
                      </Panel>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <Panel header={messageBoardHeader} id='message-panel'>
                        <Row id='message-box'>
                          {this.renderMessages()}
                        </Row>
                        <Row id='message-input'>
                          <Col xs={11}>
                            <Row>
                              {(isLAP || isAPD) && this.renderMessageColorPicker()}
                              <Col xs={(isLAP || isAPD) ? 11 : 12}>
                                <input
                                  name="ats" id="ats"
                                  value={this.state.userMessage}
                                  onChange={(e) => {
                                    this.updateSelectedUserMessage(e);
                                  }}
                                  onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                      if (this.state.userMessage.length > 0) {
                                        this.addNewMessage2();
                                      }
                                    }
                                    if (event.key === '@') {
                                      this.setUserSelectVisibility(true);
                                      setTimeout(() => {
                                        document.getElementById('ats')
                                          .blur();
                                      }, 100);
                                    }
                                  }}
                                  style={{
                                    width: '100%',
                                    height: '26px',
                                    borderRadius: '3px',
                                    border: '1px solid black',
                                    padding: '5px'
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={1}>
                            <Button
                              bsStyle="primary"
                              className="pull-right"
                              onClick={true ? this.addNewMessage2 : this.addNewMessage}
                            >
                              <em className="fa fa-paper-plane-o"/>
                            </Button>
                          </Col>
                        </Row>
                      </Panel>
                    </Col>
                  </Row>
                </Col>
                <Col xs={6}>
                  <Row>
                    <Col xs={12}>
                      <Panel header={salesOrderTablePanelHeader} className={(isLAP || isAPD) ? 'sales-80-panel' : 'sales-panel'}>
                        {(isLAP || isAPD) && this.renderSoTabs()}
                        {!(isLAP || isAPD) && this.renderSalesOrderTable()}
                        {!(isLAP || isAPD) && this.renderMobileSalesOrderTable()}
                      </Panel>
                    </Col>
                  </Row>
                </Col>
              </form>
            </Row>
            {/* End Tables */}
            {this.renderIFrame()}
          </Grid>

          <SkyLightStateless
            dialogStyles={userSelectStyle}
            isVisible={this.state.userSelectVisibility}
            onCloseClicked={this.setUserSelectVisibility}
            title={"@ User"}
          >
             <div>
              {this.renderUserTable()}
             </div>
           </SkyLightStateless>
           <SkyLightStateless
             dialogStyles={saStyle}
             isVisible={this.state.saVisibility}
             onCloseClicked={this.setSaVisibility}
             title={<Translate value="shipping_advice_details" />}
           >
            <div>
             {this.renderPODetailTable()}
            </div>
          </SkyLightStateless>

        </ContentWrapper>
      );
    }
}

export default GeneralDashboard;



// WEBPACK FOOTER //
// ./master/jsx/components/General/generalDashboardRevision.jsx